import React from "react";
import { Badge } from "reactstrap";
import PropTypes from "prop-types";
import { MasterSidebar } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";

/**
 * ActivitySidebar
 * Lista de atividades utilizando o componente padronizado MasterSidebar.
 */
const ActivitySidebar = ({ activities, activeId, onSelect, onCreateNew, loading, onReorder }) => {

    // Renderização customizada de cada item da lista de atividades
    const renderActivityItem = (activity, isActive) => (
        <div className="text-start overflow-hidden w-100">
            <div className="d-flex align-items-center mb-1">
                <div
                    className="flex-shrink-0 me-2 rounded-circle"
                    style={{
                        width: '10px',
                        height: '10px',
                        backgroundColor: activity.color || '#3b82f6',
                        border: '1px solid rgba(0,0,0,0.1)'
                    }}
                />
                <div className="d-flex align-items-center w-100 pe-2">
                    <p className={`mb-0 fw-semibold text-truncate flex-grow-1 ${isActive ? 'text-primary' : 'text-dark'}`} style={{ fontSize: '13.5px' }}>
                        {activity.name}
                    </p>
                    {activity.evaluationSystem && (
                        <i className="mdi mdi-star text-warning font-size-16" title="Possui Avaliação"></i>
                    )}
                </div>
            </div>
            <div className="d-flex align-items-center gap-2">
                <Badge
                    color={activity.status === GLOBAL_STATUS.ACTIVE ? 'success' : 'secondary'}
                    className="font-size-10 px-2 opacity-75 rounded-1"
                >
                    {activity.status === GLOBAL_STATUS.ACTIVE ? 'Ativa' : 'Inativa'}
                </Badge>
                <span className="text-muted font-size-11">
                    {activity.objectives?.length || 0} objetivos
                </span>
            </div>
        </div>
    );

    return (
        <MasterSidebar
            title="Atividades"
            subtitle="Metodologia e objetivos"
            items={activities}
            activeId={activeId}
            onSelect={onSelect}
            onCreateNew={onCreateNew}
            loading={loading}
            searchPlaceholder="Buscar atividade..."
            icon="mdi mdi-run-fast"
            renderItem={renderActivityItem}
            onReorder={onReorder}
            loadingMessage="Carregando atividades..."
        />
    );
};

ActivitySidebar.propTypes = {
    activities: PropTypes.array,
    activeId: PropTypes.string,
    onSelect: PropTypes.func,
    onCreateNew: PropTypes.func,
    loading: PropTypes.bool,
    onReorder: PropTypes.func
};

export default ActivitySidebar;
